<template>
  <div class="hotel-card" @click="handleClick">
    <div class="relative">
      <el-image class="hotel-image" :src="hotel?.images?.[0]" fit="cover" />

      <div class="logo-box">
        <img :src="hotelLogo" v-if="hotelLogo" class="logo" alt="" />
      </div>
    </div>
    <div class="hotel-info">
      <div class="hotel-name">{{ hotel?.name }}</div>
      <div class="bottom flex-nowrap whitespace-nowrap">
        <div class="tags overflow-hidden">
          <template
            v-for="(item, index) in hotel?.promotions.slice(0, 4)"
            :key="index"
          >
            <img
              v-if="item.nameIcon"
              :src="item.nameIcon"
              class="tag-item-img"
              alt=""
            />
            <y-text size="13px" v-else class="tag-item">
              {{ item.name }}
            </y-text>
          </template>
        </div>
        <div class="hotel-card-bottom-right" v-if="hotel?.minBasePrice > 0">
          <div class="place-box" />
          <div>
            <div class="price-box flex items-baseline">
              <y-text class="from">{{ t("shell.common.from") }}</y-text>
              <div class="price-content flex">
                <y-price
                  :currency="hotel.minBasePriceDetail.approximate.currency"
                  :price="hotel?.minBasePrice"
                  :decimal="2"
                  format="0,0"
                  fontSize="20px"
                />
              </div>
            </div>
            <y-text class="per-night">{{ t("shell.common.perNight") }}</y-text>
          </div>
        </div>
      </div>
    </div>
    <div class="icons">
      <Benefits :benefits="benefits" :icons="benefitIcons" />
    </div>
  </div>
</template>
<script setup>
import YPrice from "@ui/Price.vue";
import _ from "lodash";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useHotelBrandLogo } from "@/hooks/useHotelBrandLogo";

import Benefits from "./Benefits.vue";
const channelStore = useYChannelStoreHook();
const props = defineProps({
  hotel: {
    type: Object,
    default: () => ({})
  }
});

const { hotelLogo } = useHotelBrandLogo(props.hotel);

const benefits = computed(() => {
  return _.get(props.hotel, "benefits", []);
});
const benefitIcons = computed(() => {
  return channelStore.configs?.benefitIcons || {};
});

const emit = defineEmits(["select"]);
const { t } = useI18n();

const handleClick = () => {
  emit("select", props.hotel);
};
defineOptions({
  name: "HotelCardV2"
});
</script>

<style scoped lang="scss">
.hotel-card {
  cursor: pointer;
  position: relative;
  .hotel-image {
    width: 443px;
    height: var(--hotel-card-img-height, 294px);
    display: block;
  }
  .logo-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 443px;
    height: 84px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 100%
    );
    padding: 0 20px 20px;
    display: flex;
    align-items: flex-end;
    .logo {
      width: 86px;
      height: 52px;
      object-fit: contain;
    }
  }
  .hotel-info {
    background: #ffffff;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 443px;
    height: 102px;
    .hotel-name {
      font-size: 22px;
      font-family: var(--y-title-font);
      color: var(--y-title-text-color);
      line-height: 28px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    :deep(.y-price) {
      --y-price-font-size: 20px;
    }
  }

  .icons {
    position: absolute;
    top: 12px;
    left: -4px;
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2px;
    .tags {
      align-self: end;
      display: flex;
      align-items: flex-end;
      // flex-wrap: wrap;
      margin-top: 4px;
      .tag-item-img {
        height: 25px;
        margin-right: 8px;
      }
      .tag-item {
        border: 1px solid rgba(41, 41, 41, 0.2);
        background: #ffffff;
        border-radius: 3px;
        font-family: var(--y-regular-font);
        font-weight: 400;
        font-size: 13px;
        color: #292929;
        padding: 5px 7px;
        + .tag-item {
          margin-left: 8px;
        }
      }
    }
    .from {
      font-size: 12px;
      font-weight: 400;
      color: #949494;
      line-height: 12px;
      margin-bottom: 8px;
      align-self: baseline;
      margin-right: 4px;
    }

    .price-content {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }

    .per-night {
      display: block;
      font-size: 11px;
      font-weight: 400;
      color: #949494;
      line-height: 11px;
      text-align: right;
    }
  }
  .hotel-card-bottom-right {
    // display: flex;
    position: relative;
    .place-box {
      position: absolute;
      left: -32px;
      width: 32px;
      height: 39px;
      background: url("./assets/shadow.png") no-repeat;
      background-size: cover;
    }
  }
}
</style>
